// src/páginas/backoffice/CampaignsPage.jsx
import React, { useState, useEffect } from 'react';
import { PlusCircle, Edit, Trash, Tag } from 'lucide-react';
import { useSalesContext } from '../../contexts/SalesContext';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';

const CampaignsPage = () => {
  const { campaigns } = useSalesContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Simular carregamento
    setIsLoading(false);
  }, []);
  
  const handleCreateCampaign = () => {
    navigate('/backoffice/campaigns/create');
  };
  
  const handleEditCampaign = (id) => {
    navigate(`/backoffice/campaigns/edit/${id}`);
  };
  
  const handleApplyCampaign = (id) => {
    navigate('/backoffice/campaigns/apply', { state: { campaignId: id } });
  };
  
  return (
    <MainLayout>
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm p-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Campanhas Promocionais</h1>
          <p className="text-gray-500">Gerencie campanhas de descontos e promoções</p>
        </div>
        
        <button 
          className="px-4 py-2 bg-blue-900 text-white rounded-md flex items-center"
          onClick={handleCreateCampaign}
        >
          <PlusCircle className="w-4 h-4 mr-2" /> Nova Campanha
        </button>
      </div>
      
      {/* Campaigns List */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        {isLoading ? (
          <div className="animate-pulse space-y-4">
            {[1, 2, 3].map(i => (
              <div key={i} className="h-20 bg-gray-200 rounded mb-4"></div>
            ))}
          </div>
        ) : campaigns.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12">
            <Tag className="h-16 w-16 text-gray-300 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-1">Nenhuma campanha encontrada</h3>
            <p className="text-gray-500 mb-6">Crie sua primeira campanha promocional para impulsionar as vendas</p>
            <button 
              className="px-4 py-2 bg-blue-900 text-white rounded-md flex items-center"
              onClick={handleCreateCampaign}
            >
              <PlusCircle className="w-4 h-4 mr-2" /> Nova Campanha
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {campaigns.map(campaign => (
              <div 
                key={campaign.id} 
                className="border border-gray-200 rounded-lg p-4 transition-colors hover:border-blue-200 hover:bg-blue-50"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900">{campaign.name}</h3>
                    <div className="mt-1 space-x-3">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                        {campaign.discountPercentage}% de desconto
                      </span>
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                        Válido até {new Date(campaign.validUntil).toLocaleDateString('pt-BR')}
                      </span>
                    </div>
                    <p className="mt-2 text-sm text-gray-500">
                      {campaign.bonus ? `Bônus: ${campaign.bonus}` : 'Sem bônus adicionais'}
                    </p>
                  </div>
                  
                  <div className="flex space-x-2">
                    <button 
                      className="p-2 text-gray-400 hover:text-blue-900"
                      onClick={() => handleEditCampaign(campaign.id)}
                    >
                      <Edit className="w-5 h-5" />
                    </button>
                    <button className="p-2 text-gray-400 hover:text-red-600">
                      <Trash className="w-5 h-5" />
                    </button>
                  </div>
                </div>
                
                <div className="mt-4 flex justify-end">
                  <button 
                    className="px-3 py-1 text-sm text-blue-900 border border-blue-900 rounded-md hover:bg-blue-900 hover:text-white transition-colors"
                    onClick={() => handleApplyCampaign(campaign.id)}
                  >
                    Aplicar Campanha
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    </MainLayout>
  );
};

export default CampaignsPage;